'use client'

import { useEffect, useState } from 'react'
import { FaLock, FaTimes } from 'react-icons/fa'
import Portal from './Portal'

import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const filters = [
  {
    title: 'Default',
    src: '/assets/loras/random.webp',
    animeSrc: '/assets/loras/random.webp',
    plan: 'Free',
  },
  {
    title: 'Pixel XL',
    plan: 'Free',
    src: '/assets/filters/anime_pixel.webp',
    animeSrc: '/assets/filters/anime_pixel.webp',
    enabled: ['Anime XL'],
  },
  {
    title: 'Comic XL',
    plan: 'Free',
    src: '/assets/filters/anime_comic.webp',
    animeSrc: '/assets/filters/anime_comic.webp',
    enabled: ['Anime XL'],
  },
  {
    title: 'Cyberpunk',
    plan: 'Free',
    src: '/assets/filters/real_cyberpunk.webp',
    animeSrc: '/assets/filters/anime_cyberpunk.webp',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'VHS',
    plan: 'Plus',
    src: '/assets/filters/real_vhs.webp',
    animeSrc: '/assets/filters/anime_vhs.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Manga',
    plan: 'Plus',
    src: '/assets/filters/real_manga.webp',
    animeSrc: '/assets/filters/anime_manga.webp',
    enabled: [
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Flash',
    plan: 'Free',
    src: '/assets/filters/real_flash.webp',
    animeSrc: '/assets/filters/anime_flash.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Analog',
    plan: 'Free',
    src: '/assets/filters/real_analog.webp',
    animeSrc: '/assets/filters/anime_analog.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Professional',
    plan: 'Free',
    src: '/assets/filters/real_professional.webp',
    animeSrc: '/assets/filters/anime_professional.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Cinematic',
    src: '/assets/filters/real_cinematic.webp',
    animeSrc: '/assets/filters/anime_cinematic.webp',
    plan: 'Free',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Studio',
    plan: 'Free',
    src: '/assets/filters/real_studio.webp',
    animeSrc: '/assets/filters/anime_studio.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Polaroid',
    plan: 'Free',
    src: '/assets/filters/real_polaroid.webp',
    animeSrc: '/assets/filters/anime_polaroid.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Vintage',
    plan: 'Free',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      'Hardcore Flame',
    ],
  },
  {
    title: 'Hyper',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: '3D',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Sketch',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Pony Illustration XL', 'Pony Render XL', 'Pony Anime XL'],
  },
  {
    title: 'Watercolor',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Lineart',
    plan: 'Plus',
    src: '/assets/filters/real_manga.webp',
    animeSrc: '/assets/filters/anime_manga.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Moody',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Oil Painting',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Rainbow',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Artsy',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Artsy 2',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cartoon',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cartoon Vintage',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Painted',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cartoon 2',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cartoon 3',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Minimalist',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Character Sheet',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Vintage Comic',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Pixel Art',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Anime Studio',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Polariod Picture',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Flash Photo',
    plan: 'Plus',
    src: '/assets/filters/ponyFilters/Flash Photo.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Pony Photo XL 2', 'Pony XL 2', 'Pony Photo XL', 'Pony XL'],
  },
  {
    title: 'Noir Movie',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Analog Photo',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Pony Photo XL 2', 'Pony XL 2', 'Pony Photo XL', 'Pony XL'],
  },
  {
    title: 'Vintage Photo',
    plan: 'Plus',
    src: '/assets/filters/real_vintage.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Snap',
    plan: 'Free',
    src: '/assets/filters/flame/Snap.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Cinematic Flame', 'Hardcore Flame'],
  },
  {
    title: 'Film',
    plan: 'Free',
    src: '/assets/filters/flame/Film.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Cinematic Flame', 'Hardcore Flame'],
  },
  {
    title: 'DLSR',
    plan: 'Free',
    src: '/assets/filters/flame/DLSR.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Monochrome',
    plan: 'Free',
    src: '/assets/filters/flame/Monochrome.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Disposable',
    plan: 'Free',
    src: '/assets/filters/flame/Disposable.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Cinematic Flame'],
  },
  // Hardcore Flame only: its own text in the backend's var/style_filters.py (`hardcore_*`).
  {
    title: 'Y2K',
    plan: 'Free',
    src: '/assets/filters/flame/Y2K.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Hardcore Flame'],
  },
  {
    title: 'Snap Night',
    plan: 'Free',
    src: '/assets/filters/flame/Snap Night.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Hardcore Flame'],
  },
  {
    // Shown as "Cinematic" (i18n "hardcore cinematic"); the legacy 'Cinematic' filter's label is "Moody".
    title: 'Hardcore Cinematic',
    plan: 'Free',
    src: '/assets/filters/flame/Hardcore Cinematic.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Hardcore Flame'],
  },
  {
    title: 'Phone',
    plan: 'Free',
    src: '/assets/filters/flame/Phone.webp',
    animeSrc: '/assets/filters/anime_vintage.webp',
    enabled: ['Hardcore Flame'],
  },
]
const animeList = [
  'Anime',
  'Hyperanime',
  'Fur',
  'Furtoon',
  'Anime XL',
  'Pony Anime XL',
  'Anime Flame',
  'Pony Render XL',
  'Pony Illustration XL',
]

const FiltersModal = ({
  isOpen,
  closeModal,
  setFilter,
  subscription,
  filter,
  model,
  safe,
}) => {
  const { t } = useTranslation()
  const { isPlusOrHigher, isPremiumOrHigher, isStudioOrHigher } = useAuth()
  const [selectedImage, setSelectedImage] = useState(null)
  const [shouldRender, setShouldRender] = useState(isOpen)

  useEffect(() => {
    if (isOpen) setShouldRender(true)
  }, [isOpen])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset'
  }, [isOpen])

  useEffect(() => {
    const currentFilter = filters.find((item) => item.title === filter)
    const modelNotEnabled =
      currentFilter?.enabled && !currentFilter.enabled.includes(model)

    if (modelNotEnabled) {
      setFilter('Default')
    }
  }, [model, filter, setFilter])

  const canSelectImage = (imagePlan) => {
    switch (imagePlan) {
      case 'Free':
        return true
      case 'Plus':
        return isPlusOrHigher
      case 'Premium':
        return isPremiumOrHigher
      case 'Pro':
      case 'Studio':
        return isStudioOrHigher
      default:
        return false
    }
  }

  const isFilterEnabledForModel = (image) =>
    !image?.enabled || image.enabled.includes(model)

  const handleImageClick = (e, image) => {
    e.preventDefault()

    if (!isFilterEnabledForModel(image)) {
      setFilter('Default')
      closeModal()
      return
    }

    if (!canSelectImage(image.plan)) {
      if (typeof window !== 'undefined') window.location.href = '/upgrade'
    } else {
      setSelectedImage(image)
      setFilter(image.title)
      closeModal()
    }
  }

  if (!shouldRender) {
    return null
  }

  return (
    <Portal>
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeModal()
          }
        }}
        className={`fixed z-[110] top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center ${
          isOpen ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-200 ${
          isOpen ? 'pointer-events-auto' : 'pointer-events-none'
        }`}
      >
        <div
          className={`bg-[var(--middle-bg-color)] h-3/4 md:h-2/3 w-3/4 md:w-2/3 flex flex-col rounded-lg shadow-2xl p-6 text-gray-100 space-y-4 relative transform transition-all duration-200 ${
            isOpen ? 'scale-100 opacity-100' : 'scale-70 opacity-0'
          }`}
        >
          <header>
            <h2 className="text-xl font-semibold text-shadow">
              {t(filter?.toLowerCase())}
            </h2>

            <button
              onClick={closeModal}
              className="absolute right-2 top-2 m-4 text-white"
              style={{ fontSize: '1.5rem' }}
            >
              <FaTimes />
            </button>
          </header>

          <hr className="border-gray-800" />

          <main className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-1 overflow-y-auto overflow-x-hidden flex-grow p-4">
            {filters
              .filter(
                (image) =>
                  image.title === 'Default' || isFilterEnabledForModel(image),
              )
              .map((image) => (
                <div
                  key={image.title}
                  className={`m-1 border-2 relative aspect-/ aspect-h-1 rounded-xl transition-all duration-200 ease-in-out ${
                    image === selectedImage
                      ? 'border-white shadow-outline-blue'
                      : canSelectImage(image.plan)
                        ? 'border-transparent hover:shadow-lg hover:border-gray-800 hover:scale-[1.03] cursor-pointer'
                        : 'border-transparent'
                  }`}
                  onClick={(e) => handleImageClick(e, image)}
                >
                  <img
                    src={
                      safe || image.title === 'Default'
                        ? '/assets/models/random.webp'
                        : animeList.includes(model)
                          ? `/assets/filters/ponyAnimeFilters/${image.title}.webp`
                          : `/assets/filters/ponyFilters/${image.title}.webp`
                    }
                    alt={image.title}
                    className={`w-full h-full object-cover object-top rounded-xl ${
                      canSelectImage(image.plan) ? '' : 'opacity-50'
                    }`}
                    onError={(e) => {
                      const fallbackSrc = image.src || image.animeSrc

                      e.currentTarget.onerror = null
                      e.currentTarget.src = animeList.includes(model)
                        ? image.animeSrc || fallbackSrc
                        : fallbackSrc
                    }}
                  />

                  {!canSelectImage(image.plan) ? (
                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-xl">
                      <span className="text-gray-300 flex items-center">
                        <FaLock className="mr-1" /> {image.plan}
                      </span>

                      <p className="font-semibold absolute bottom-0 mb-2 ml-2 text-gray-300 text-sm bg-black bg-opacity-50 rounded px-1">
                        {t(image.title?.toLowerCase())}
                      </p>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <p className="font-semibold absolute bottom-0 mb-2 ml-2 text-white text-sm bg-black bg-opacity-50 rounded px-1">
                        {t(image.title?.toLowerCase())}
                      </p>
                    </div>
                  )}
                </div>
              ))}
          </main>
        </div>
      </div>
    </Portal>
  )
}

export default FiltersModal
